import { BaseMapper } from '@ps/utils';
import { Option } from '@sapphire/result';

import { QuestionDetail } from '../../models/question-detail.model';
import { QuestionDetailDto } from '../dtos/question-detail.dto';
import { LocalizationMapper } from './localization.mapper';

export class QuestionDetailMapper extends BaseMapper<
  QuestionDetailDto,
  QuestionDetail
> {
  private readonly _localizationMapper = new LocalizationMapper();

  public fromDto(dto: QuestionDetailDto): QuestionDetail {
    return {
      id: dto.qualification_code,
      attributeId: dto.attribute_id,
      desc: dto.desc,
      isHidden: dto.is_hidden,
      companyIds: Option.from(dto.cmp).unwrapOr([]),
      class: dto.class,
      recency: Option.from(dto.recency).unwrapOr(0),
      category: Option.from(dto.category)
        .unwrapOr([])
        .map((category) => ({ id: category.id, label: category.label })),
      categoryIds: Option.from(dto.category)
        .unwrapOr([])
        .map((category) => category.id),
      answerOrder: Option.from(dto.answer_order).unwrapOr(null),
      type: dto.type,
      tags: Option.from(dto.tags).mapOr([], (rawTags) =>
        rawTags.split(',').map((tag) => tag.trim()),
      ),
      buyerText: Option.from(dto.buyer_text).unwrapOr(''),
      stem1: Option.from(dto.stem1).unwrapOr(''),
      stem2: Option.from(dto.stem2).unwrapOr(''),
      createSurveyOrder: Option.from(dto.create_survey_question_order || null)
        .map(Number)
        .unwrapOr(null),
      localizations: this._localizationMapper.fromDtoList(
        Option.from(dto.localizations).unwrapOr([]),
      ),
    };
  }
}
